module.exports = __webpack_public_path__ + "img/energy_red.1ae97af9.svg";